import React, {useEffect, useState} from 'react';
import {Popover} from '@mantine/core';

import {Container, Input, Button, OptionList, Option} from './styles';
import {SelectDataProps} from 'shared/types/select-data';

interface Props {
  value?: string | boolean;
  handleConfirm: (value: string) => void;
  options: SelectDataProps[];
  search?: boolean;
  centerValue?: boolean;
  opened: boolean;
  setOpened: (opened: boolean) => void;
  placement?: 'center' | 'start' | 'end';
  themeLess?: boolean;
}

const SelectFilter: React.FC<Props> = ({
  handleConfirm,
  value,
  options,
  search = false,
  centerValue = false,
  opened,
  setOpened,
  placement = 'start',
  themeLess,
}) => {
  const [searchText, setSearch] = useState('');
  const [label, setLabel] = useState(
    options.find((option) => option.value === value)?.label ?? '',
  );

  useEffect(() => {
    if (value === false || value)
      setLabel(options.find((option) => option.value === value)?.label ?? '');
  }, [value]);

  useEffect(() => {
    if (!label && value)
      setLabel(options.find((option) => option.value === value)?.label ?? '');
  }, [options]);

  const availableOptions = options.filter(
    (option) =>
      option.label.toLocaleLowerCase().search(searchText.toLocaleLowerCase()) >=
      0,
  );

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      zIndex={1001}
      position="bottom"
      {...{placement}}
      styles={{dropdown: {padding: 0}}}>
      <Popover.Target>
        <Button
          onClick={() => setOpened(true)}
          active={opened}
          {...{themeLess}}>
          {label}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Container full={search}>
          {search && (
            <Input
              placeholder="Pesquisar"
              autoFocus
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
          <OptionList>
            {availableOptions.map((option, index) => (
              <Option
                className="ignore"
                {...{centerValue, active: value === option.value}}
                key={index}
                onClick={() => {
                  handleConfirm(option.value);
                  setLabel(option.label);
                }}>
                {option?.label}
              </Option>
            ))}
          </OptionList>
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default SelectFilter;
